<div
  [ngClass]="backgroundClasses + ' ' + containerClasses"
  [style]="containerStyles"
>
  <div class="img-block" *ngIf="fullWidthBackground && cmsImage?.src">
    <digital-platform-picture
      [altText]="cmsImage?.alt || ''"
      [width]="cmsImage?.width || 0"
      [height]="cmsImage?.height || 0"
    ></digital-platform-picture>
  </div>
  <div class="text-block">
    <div class="content-container-constrain" [class]="containerPaddingClasses">
      <div class="img-block" *ngIf="!fullWidthBackground && cmsImage?.src">
        <digital-platform-picture
          [webpSrc]="cmsImage?.src || ''"
          [altText]="cmsImage?.alt || ''"
          [width]="cmsImage?.width || 0"
          [height]="cmsImage?.height || 0"
        ></digital-platform-picture>
      </div>

      <div
        [ngClass]="itemsWrapperClass"
        [class.row]="containerType?.containerClass && !isRowContainerType"
      >
        <div class="col-xs-12">
          <div
            [class]="childWrapperClasses"
            [style]="childWrapperInlineStyle"
            [ngStyle]="{ 'min-height.px': height }"
          >
            <div
              *ngFor="let content of nestedFlexboxItem"
              [ngClass]="[
                concatChildClasses(content),
                getInnerClasses(content)
              ]"
              [style]="getInnerInlineStyles(content)"
            >
              <digital-platform-dynamic-content-wrapper
                [config]="content"
              ></digital-platform-dynamic-content-wrapper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
